<template>
  <div>
    <MainHeader />

    <Account v-if="init && (profile)" />

    <div v-else>
      Please log in to see your account settings..
    </div>

    <Footer />
  </div>
</template>

<script>
  import MainHeader from '@/components/generic/MainHeader.vue'
  import Footer from '@/components/generic/Footer.vue'

  import Account from '@/components/home/user/Account.vue'
  export default {
    name: 'home',
    components: {
      MainHeader, Footer, Account
    },
    computed: {
        profile() {
            return this.$store.state.profile
        },
        init() {
          return this.$store.state.init
        }
    }
  }
</script>

<style scoped>
    div.container {
        background-color:#fff;
    } 
</style>
